import { config } from '../constants/config_constants';

const RENDER_ENDPOINT = config.endpoints.RENDERING_ENDPOINT;

class BSContentService {

    static getTransparentAvatarForComicId(comicId, avatarId) {
        return `${RENDER_ENDPOINT}render/panel/${comicId}-${avatarId}` +
            '-v1.png?transparent=1&palette=1';
    }
}

export default BSContentService;


// WEBPACK FOOTER //
// ./src/services/BSContentService.js